import { ITreeNode } from "./IHVTreeView";

export const addChild = (
  nodes: ITreeNode[],
  parentId: string,
  newNode: ITreeNode,
): ITreeNode[] => {
  return nodes.map((node) => {
    if (node.id === parentId) {
      return {
        ...node,
        children: [...(node.children ?? []), newNode],
      };
    } else if (node.children) {
      return {
        ...node,
        children: addChild(node.children, parentId, newNode),
      };
    }
    return node;
  });
};

export const updateLabel = (
  nodes: ITreeNode[],
  id: string,
  newLabel: string,
): ITreeNode[] => {
  return nodes.map((node) => {
    if (node.id === id) {
      return { ...node, itemProps: { ...node.itemProps, label: newLabel } };
    }
    if (node.children) {
      return { ...node, children: updateLabel(node.children, id, newLabel) };
    }
    return node;
  });
};

export const removeNode = (nodes: ITreeNode[], id: string): ITreeNode[] => {
  return nodes
    .filter((node) => node.id !== id)
    .map((node) => ({
      ...node,
      children: node.children ? removeNode(node.children, id) : node.children,
    }));
};

export const findNodeById = (
  nodes: ITreeNode[],
  id: string,
): ITreeNode | undefined => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

export const flattenTree = (
  nodes: ITreeNode[],
  expandedNodes: Set<string>,
  level = 0,
): Array<ITreeNode & { level: number }> => {
  let result: Array<ITreeNode & { level: number }> = [];

  for (const node of nodes) {
    result.push({ ...node, level });
    if (node.children && expandedNodes.has(node.id)) {
      result = result.concat(
        flattenTree(node.children, expandedNodes, level + 1),
      );
    }
  }
  return result;
};
